import { useEffect, useRef, useState } from "react";
import { useFindProduct } from "../../Services/Api";
import useSound from "use-sound";
import err from '../Form/sounds/err.mp3';


/**форма поиска товара по части названия или части артикула 1с */
const Find = () => {
  const [findSting, setFindString] = useState('');
  const [oldFindString, setOldFindString] = useState('')
  const [alarmed, setAlarmed] = useState(false);
  const [findResult, setFindResult] = useState([]);
  const [alarmMessage, setAlarmMessage] = useState('')
  const keyboardTimeout = useRef(null);
  const findRef = useRef(null);
  const [playErr] = useSound(err);




  useEffect(() => {
    findRef.current.focus();
    setOldFindString('')
    return () => {
      clearTimeout(keyboardTimeout.current)
    }
  }, [])

  const onFindResultLoad = (result) => {
    // console.log(result)
    setOldFindString(findSting)
    setFindString('')
    findRef.current.focus();
    if (result?.payload?.data && Array.isArray(result.payload.data)) {
      setFindResult(result.payload.data)
    }
    if (result?.payload?.alarm === true) {
      playErr()
      setAlarmed(true)
    } else {
      setAlarmed(false)
    }
    if (result?.payload?.alarmMessage) {
      setAlarmMessage(result.payload.alarmMessage)
    } else {
      setAlarmMessage('')
    }
  }

  const find = useFindProduct(onFindResultLoad, () => { });

  const findHandleChange = (e) => {
    clearTimeout(keyboardTimeout.current)
    //пустые строки мы не шлем в код
    if (!!e.target.value) {
      keyboardTimeout.current = setTimeout(() => {
        find({ findString: e.target.value, })
      }, 300);
    }
    setFindString(e.target.value)
  }
  const tempFindResult = Array.isArray(findResult?.[0]) ? findResult[0] : findResult
  return (
    <>
      <div className="mainForm">
        <div className="gForm cont">
          <h2>Поиск</h2>
          
          <input ref={findRef} type="text" value={findSting} onChange={findHandleChange} />
          <div style={{ ...(alarmed ? { backgroundColor: "red" } : {}), minHeight: "20px", border: 'black solid 1px', margin: '5px 0' }}>
            {oldFindString || null}
          </div>
          <div style={{ minHeight: "24px" }}>
            {alarmMessage !== '' ? (<h3 style={{ color: "red", margin:0 }}>{alarmMessage}</h3>) : null}
          </div>
        </div>
      </div >
      <span className="findedCount">Найдено {findResult.length} товаров</span>
      <table className="findResult">
        <thead>
          <tr>
            <td>ID</td>
            <td>Артикул</td>
            <td>Штрихкод</td>
            <td>Название</td>
            <td>Номер эмиссии</td>
            <td>КМ</td>
            <td>Статус КМ</td>
            <td>КМ обновлен</td>
            <td>Дата про-ва</td>
            <td>Агрегат</td>
            <td>Статус агрегата</td>
            <td>Агрегат создан</td>
            <td>Всего в агрегате</td>
            <td>Имя пользователя</td>

            <td>Код 1с</td>
            <td>GTIN</td>


            {/* <td>Артикул</td>
                <td>Код 1с</td>
                <td>GTIN</td>
                <td>Название</td>
                <td>Здесь всего</td>
                <td>Здесь готово</td>
                <td>Здесь осталось</td>
                <td>Всего готово</td>
                <td>Всего осталось</td> */}
          </tr>
        </thead>
        <tbody>
          {tempFindResult.map(({
            goodsId,
            art,
            barCode,
            goodsName,
            orderNumber,
            km,
            kmStatus,
            kmUpdated,
            kmProdDate,
            aggrCode,
            aggrStatus,
            aggrCreated,
            aggrCodesCount,
            userName,

            code1s,
            gtin,





            // art,
            // code1s,
            // gtin,
            // goodsName,
            // curentPointStock,
            // curentPointCompleteCount,
            // curentPointLeftCount,
            // totalCompleteCount,
            // totalLeftCount,
          }) => (
            <tr>
              <td>{goodsId}</td>
              <td>{art}</td>
              <td>{barCode}</td>
              <td>{goodsName}</td>
              <td>{orderNumber}</td>
              <td>{km}</td>
              <td>{kmStatus}</td>
              <td>{kmUpdated}</td>
              <td>{kmProdDate}</td>
              <td>{aggrCode}</td>
              <td>{aggrStatus}</td>
              <td>{aggrCreated}</td>
              <td>{aggrCodesCount}</td>
              <td>{userName}</td>

              <td>{code1s}</td>
              <td>{gtin}</td>




              {/* <td>{art}</td>
              <td>{code1s}</td>
              <td>{gtin}</td>
              <td>{goodsName}</td>
              <td>{curentPointStock}</td>
              <td>{curentPointCompleteCount}</td>
              <td>{curentPointLeftCount}</td>
              <td>{totalCompleteCount}</td>
              <td>{totalLeftCount}</td> */}
            </tr>
          ))}
        </tbody>
      </table>
    </>

  )
}

export default Find;